// @flow
import WellCard from './WellCard'

export interface WellFileImport {
    description: {
        name: String,
        type: String,
        water_depth: string | number,
        final_depth: string | number,
        wellhead_elevation: number,
        production_unit: String,
        goal: string,
        rotaryTable: number
    };
    location: {
        country: String,
        region: string,
        field: String,
        latitude: string | number,
        longitude: string | number
    };
    sections: {
        sections: Array<{
            bit_diameter: string,
            casing_diameter: string,
            final_md: number,
            fluid_type: string,
            fluid_weight: number,
            id: string,
            md_casing_shoe: number,
            top_of_cement: number,
            well_bores?: Record<string, unknown>,
            drill_strings?: Record<string, unknown>,
            BHAs?: Record<string, unknown>,
            drilling_fluids?: Array<Record<string, unknown>>,
            operations?: Record<string, unknown>
        }>
    };
    pressures: {
        fracture: Array<{
            quota: number,
            md: number,
            pressure: number
        }>,
        pore: Array<{
            quota: number,
            md: number,
            pressure: number
        }>
    };
    trajectory: Array<{
        md: number,
        inclination: number,
        azimuth: number,
        tvd: number,
        horizontalDisplacement: number
    }>;
    temperature: {
        water_depth: Array<{
            quota: number,
            md: number,
            temperature: number
        }>,
        profile: Array<{
            quota: number,
            md: number,
            temperature: number
        }>
    };
    restore: {
        description: any,
        location: any,
        section: any,
        geoPression: any,
        trajectory: any,
        temperature: any
    };

    imported: boolean;
    restored: boolean;

    wellCard: WellCard;
}
